import { render, staticRenderFns } from "./ReviewScreen.vue?vue&type=template&id=07f9be6d&scoped=true&"
import script from "./ReviewScreen.vue?vue&type=script&lang=js&"
export * from "./ReviewScreen.vue?vue&type=script&lang=js&"
import style0 from "./ReviewScreen.vue?vue&type=style&index=0&id=07f9be6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f9be6d",
  null
  
)

export default component.exports